<template>
  <h1 class="title-text">
      {{ getResidentialHouseTypeName !== $t('messages_nl.rental.typePluralOrNot.residentialHouse', { count: 1 }).toLowerCase()
      ? capitalizeFirstLetter($t('messages_nl.catalog.h1Alternative', { rentalType: getResidentialHouseTypeName, location }))
      : $t('messages_nl.rental.typePluralOrNot.residentialHouse', { count: 0 }) + ' ' + location
      }}
  </h1>
</template>

<script>
import shared from '../../../../../common/vue/components/search/text/shared';

export default {
  name: "adivare-text-title",
  extends: shared,
  computed: {
    getResidentialHouseTypeName() {
      return this.rentalTypeName(1);
    }
  }
}
</script>
